import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faWarning,
  faClock,
  faArrowUp
} from "@fortawesome/free-solid-svg-icons";

const StockAlerts = ({ alerts = [], loading = false }) => {
  if (loading) {
    return <div className="text-center p-3 text-xs">Carregando...</div>;
  }

  // Garantir que alerts é um array
  const alertsArray = Array.isArray(alerts) ? alerts : [];

  if (!alertsArray.length) {
    return (
      <div className="bg-white p-3 rounded-lg shadow">
        <h3 className="text-xs font-semibold mb-2 flex items-center">
          <FontAwesomeIcon icon={faWarning} className="mr-2 text-green-600" size="sm" />
          Alertas de Stock
        </h3>
        <p className="text-xs text-neutral-500">Nenhum alerta.</p>
      </div>
    );
  }

  const getAlertConfig = (alertType) => {
    switch(alertType) {
      case 'excesso':
        return {
          icon: faArrowUp,
          color: 'text-purple-600',
          bg: 'bg-purple-100',
          text: 'text-purple-800',
          label: 'Excesso'
        };
      case 'mais curado':
        return {
          icon: faClock,
          color: 'text-blue-600',
          bg: 'bg-blue-100',
          text: 'text-blue-800',
          label: 'Mais curado'
        };
      case 'queijo perto do tempo de estragar':
        return {
          icon: faExclamationTriangle,
          color: 'text-red-600',
          bg: 'bg-red-100',
          text: 'text-red-800',
          label: 'Perto do vencimento'
        };
      default:
        return {
          icon: faWarning,
          color: 'text-yellow-500',
          bg: 'bg-yellow-100',
          text: 'text-yellow-800',
          label: 'Alerta'
        };
    }
  };

  return (
    <div className="bg-white p-3 rounded-lg shadow flex flex-col max-h-[320px]">
      <h3 className="text-xs font-semibold mb-2 flex items-center flex-shrink-0">
        <FontAwesomeIcon icon={faWarning} className="mr-2 text-orange-500" size="sm" />
        Alertas de Stock
      </h3>
      <div className="space-y-1 overflow-y-auto flex-1 min-h-0">
        {alertsArray.slice(0, 10).map((alert, index) => {
          const alertConfig = getAlertConfig(alert.alert_type);
          return (
            <div key={`${alert.id}-${alert.alert_type}-${index}`} className="flex items-center justify-between p-1.5 bg-neutral-50 rounded text-xs">
              <div className="flex items-center space-x-2 flex-1 min-w-0">
                <FontAwesomeIcon icon={alertConfig.icon} className={alertConfig.color} size="sm" />
                <div className="min-w-0 flex-1">
                  <p className="font-medium text-xs truncate">{alert.name}</p>
                  <p className="text-xs text-neutral-500 truncate">
                    {alert.alert_type === 'excesso'
                      ? `Stock: ${alert.current_stock_kg}kg`
                      : alert.days_to_expiry !== null
                        ? `${alert.lot_number ? `Lote: ${alert.lot_number} · ` : ''}Vence em ${alert.days_to_expiry}d`
                        : 'Verificar'
                    }
                  </p>
                </div>
              </div>
              <div className="text-right ml-1 flex-shrink-0">
                <span className={`px-1 py-0 rounded text-xs whitespace-nowrap ${alertConfig.bg} ${alertConfig.text}`}>
                  {alertConfig.label}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StockAlerts;
